import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { DictionaryModule } from '@sdbn/appclient';
import { TruckInfoPanelComponent } from './truck-info-panel.component';
import { CommonTranslationModule } from '@sdbn/common';



@NgModule({
  declarations: [TruckInfoPanelComponent],
  exports: [TruckInfoPanelComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    DictionaryModule,
    ApplicationClientCommonModule,
    CommonTranslationModule
  ]
})
export class TruckInfoPanelModule { }
